import { DriverModel } from './dashboard.models';

export class HeaderModel {
    driver: DriverModel;
    driverId: string;
    date: string;
    truckType: string;
    note: string;
}

export class DriverTableRecord {
    id: string;
    headerId: string;
    gsmId: string;
    gsmName: string;
    product: string;
    capacity: string;
    ullage: string;
    required: number;
    action: string;
    lat: string;
    log: string;
}